module.exports = __webpack_public_path__ + "img/logo_cassems.5751ed7a.png";